.datePicker input {
  width: 130px;
  padding: 5px;
  height: 35px;
}

.icon {
  width: 35px;
  height: 35px;
  padding: 0 !important;
}

.datePickerContainer {
  display: flex;
}

.datePickerItemContainer {
  display: flex;
  margin-right: 1em;
}

.invalid {
  border: 2px solid var(--red);
  padding: 0.25em;
}
